import styled from "@emotion/styled";
import { Modal } from "react-bootstrap";
import { IStyledComponentProps } from "../../theme/theme.types";

const LocationModal = styled(Modal)<IStyledComponentProps>`
  .location-modal {
    width: 375px;
    .modal-body {
      padding-top: 0;
    }
    .modal-footer {
      border-top: none;
    }
  }
`;

const NotFoundModal = styled(Modal)<IStyledComponentProps>`
  .not-found-modal {
    width: 375px;
    .modal-body {
      padding-top: 0;
      text-align: center;
    }
    .modal-footer {
      border-top: none;
      justify-content: center;
    }
  }
`;

const OutageReconciliationModal = styled(Modal)<IStyledComponentProps>`
  .outage-reconciliation-modal {
    .modal-content {
      min-height: 450px;

      .label-column {
        padding: 0;
        padding-right: 0.25rem;
        font-family: ${(props) => props.theme.fontFamilies.semiBold};
      }
      .value-column {
        padding-left: 0;
      }

      .modal-header {
        .label-column {
          flex: 0.25;
        }
      }

      .modal-body {
        .nav-link {
          &:hover {
            &.active {
              cursor: default;
            }

            &:not(.active) {
              cursor: pointer;
            }
          }
        }

        .contact-info-container {
          margin-bottom: 24px;
          margin-left: 18px;
          .label-column {
            flex: 0.15;
          }
        }
        .tab-nav {
          margin-left: 18px;
        }
      }
    }
  }
`;

const PinModeModal = styled(Modal)<IStyledComponentProps>`
  .pin-mode-modal {
    width: 375px;
    position: absolute;
    top: 10px;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 10040;
    overflow: auto;
    overflow-y: auto;
    .modal-body {
      padding-top: 0;
    }
    .modal-footer {
      border-top: none;
      button {
        width: 100%;
      }
    }
  }
`;

const LocationModalHeader = styled(Modal.Header)<IStyledComponentProps>`
  &.location-modal-header {
    border-bottom: none;
    .modal-title {
      font-family: ${(props) => props.theme?.fontFamilies?.semiBold};
      font-size: ${(props) => props.theme.utils.increaseFontSize(6)};
    }
  }
`;

const NotFoundModalHeader = styled(Modal.Header)<IStyledComponentProps>`
  &.not-found-modal-header {
    border-bottom: none;
    margin-bottom: 18px;
    .icon-container {
      background-color: ${(props) => props.theme.colors.alerts.secondary};
      border-radius: 50%;
      width: 80px;
      height: 80px;
      margin: 12px auto;
      img {
        width: 65px;
        height: 65px;
        margin: 8px;
      }
    }

    .modal-title {
      font-family: ${(props) => props.theme?.fontFamilies?.semiBold};
      font-size: ${(props) => props.theme.utils.increaseFontSize(6)};
      text-align: center;
    }
  }
`;

const PinModeModalHeader = styled(Modal.Header)<IStyledComponentProps>`
  &.pin-mode-modal-header {
    border-bottom: none;
    .modal-title {
      font-family: ${(props) => props.theme?.fontFamilies?.semiBold};
      font-size: ${(props) => props.theme.utils.increaseFontSize(6)};
    }
  }
`;

export default {
  LocationModal,
  PinModeModal,
  NotFoundModal,
  NotFoundModalHeader,
  LocationModalHeader,
  OutageReconciliationModal,
  PinModeModalHeader,
};
